import { Alert, Button, CircularProgress, Grid } from '@mui/material';
import React, { useState } from 'react';

const UploadJSONForm = ({
  handleSubmit,
  handleFile,
  files,
  loading,
  handleCloseJSONPopup,
}) => {
  const [showError, setShowError] = useState(false);

  return (
    <Grid container spacing={2}>
      {!loading && (
        <>
          <Grid item xs={12} sm={12}>
            <label>Please select a CSV file</label>
          </Grid>
          <Grid item xs={12} sm={12}>
            <input
              type="file"
              accept=".csv"
              onChange={(e) => {
                setShowError(false);
                handleFile(e);
              }}
            />
          </Grid>
        </>
      )}
      {loading && (
        <Grid item xs={12} sm={12}>
          <Alert severity="info">
            Creating products... This might take some time.
          </Alert>
        </Grid>
      )}
      <Grid item xs={12} sm={12}>
        {loading ? (
          <Button
            variant="contained"
            type="button"
            fullWidth
            onClick={handleCloseJSONPopup}
            sx={{ minHeight: 50, fontSize: 16, mt: 5 }}>
            Close
          </Button>
        ) : (
          <Button
            variant="contained"
            type="button"
            fullWidth
            disabled={!files || files.length === 0 || files.length > 50}
            onClick={handleSubmit}
            sx={{ minHeight: 50, fontSize: 16, mt: 5 }}>
            {loading ? <CircularProgress /> : showError ? 'Continue' : 'Submit'}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default UploadJSONForm;
